import { DefaultLocale } from "inbox-contentful";
import React from "react";
import { useParams } from "react-router-dom";

type ParamsWithLang = { lang: string };

export const withSelectedLocale = (Component) => (props) => {
    const { lang } = useParams<ParamsWithLang>();

    const { localization } = props;
    const { available, locales } = localization;
    const validLang = lang && available.includes(lang) ? lang : DefaultLocale;
    const locale = {
        ...locales[DefaultLocale],
        ...locales[validLang],
        lang: validLang,
    };

    return <Component {...props} locale={locale} />;
};
